import axios from "axios";
import { getAccessToken, getLocalTimeZone } from "./commonService";
import { apiPath, APP_URL, REACT_APP_X_API_KEY, HOST_TYPE } from "./apiPath";
import { ShowToast } from "../components/show-toast/ShowToast";

export const uploadFilesToS3 = async (filesToUpload, hideToast = false) => {
  const fileData = filesToUpload.map((file) => ({
    file_extension: file.name.substring(file.name.lastIndexOf(".") + 1),
    path: file.path,
  }));

  try {
    // Step 1: Get signed URLs for files
    const res = await axios.post(APP_URL + apiPath.getMultiSignedUrl, {
      token: getAccessToken(),
      file_data: fileData,
    }, {
      headers: {
        language: localStorage.getItem('i18nextLng'),
        'Accept-Language': localStorage.getItem('i18nextLng'),
        timezone: getLocalTimeZone(),
        'x-api-key': REACT_APP_X_API_KEY,
        'hosttype': HOST_TYPE,
        'device': navigator.userAgent,
        'ip': localStorage.getItem('userIP')
      },
    });

    const signedUrlData = res.data.data;

    // Check if signed URLs were returned
    if (!signedUrlData || signedUrlData.length === 0) {
      ShowToast("error", "No signed URLs returned.");
      return null;
    }

    // Step 2: Upload each file using its signed URL
    const uploadPromises = signedUrlData.map(async (presignedPostData, index) => {
      const file = filesToUpload[index]; // Get the corresponding file

      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: file,
      };

      console.log("presignedPostData", presignedPostData)

      try {
        const resp = await fetch(presignedPostData.url, requestOptions);

        if (!resp.ok) throw new Error("Upload failed");

        // Success Toast
        if (!hideToast) {
          ShowToast("success", `File ${ file.name } uploaded successfully.`);
        }

        return { url: presignedPostData.preview_file_url, filename: presignedPostData.filename };
      } catch (error) {
        if (!hideToast) {
          ShowToast("error", `Failed to upload ${ file.name }`);
        }
        console.error(`Error uploading ${ file.name }:`, error);
        return false;
      }
    });

    // Wait for all uploads to complete
    const results = await Promise.all(uploadPromises);

    return results; // Returns array with individual upload results
  } catch (error) {
    console.error("Error getting signed URLs:", error);
    ShowToast("error", "Failed to get signed URLs.");
    return null;
  }
};

//Upload file to AWS S3
const uploadFileToS3 = async (file, pathName, hideToast = false) => {
  try {
    let fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);
    let res = await axios.post(APP_URL + apiPath.getSignedUrl, {
      file_extension: fileExtension,
      path: pathName,
      token: getAccessToken()
    }, {
      headers: {
        language: "en",
        'x-api-key': REACT_APP_X_API_KEY,
        'timezone': getLocalTimeZone(),
        'hosttype': HOST_TYPE,
        'ip': localStorage.getItem('userIP'),
        'device': navigator.userAgent
      },
    });
    let presignedPostData = res.data.data;
    const formData = new FormData();
    const url = presignedPostData.preview_file_url;
    const filePath = presignedPostData.filename;
    // append the file
    formData.append("file", file);

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    };
    console.log("presignedPostData", presignedPostData);
    const resp = await fetch(presignedPostData.url, requestOptions)
      .then(function () {
        if (!hideToast) {
          ShowToast("success", "File Uploaded Successfully");
        }

        return { url: url, filename: filePath };
      })
      .catch(function (error) {
        ShowToast("error", error);
        return false;
      });
    return resp;
  } catch (error) {
    return false;
  }
};

export default uploadFileToS3;